<template>
    <div>
    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>Struktur Organisasi</h4>
                <div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                		<li><a href="/">Profil</a></li>
                    <li><router-link to="/struktur_organisasi">Struktur Organisasi</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
      
      
      <!--Content Wrap Start-->
      <div class="kode_content">        
        <section class="kode_about_welcome">
            <div class="container">
            	<div class="row">                
                    <div class="col-md-12">
                        <div class="kode_wel_demo_des">
                            <h4>Struktur Organisasi</h4>
                            <p v-html="uraian"></p>
                        </div>
                    </div>                    
            	</div>
            </div>
        </section>          
      </div>        
    </div>
</template>


<script>

const ADD_URL = URL_APP + "api/v1/publish_struktur_organisasi/";
const FILE_LOAD = URL_APP + "uploads/";

    export default {
        data(){
            return{
                id: "",
                id_berita :"",
                createAt : '',
                createBy : '',
                deskripsi : '',
                nama: '',
                nip: '',
                jabatan: '',
                trackr: '',
                uraian : '',
                judul : '',
                sumber : '',
                foto : '',
                HOST : URL_HOST+'/isi_berita/',
                file_path: FILE_LOAD,

                list_data: [],
                page_first: 1,
                page_last: 0,
                cari_value: "",
            }
        },

        methods: {
        getView: function() {
        fetch(ADD_URL + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            },
            body: JSON.stringify({
            data_ke: this.page_first,
            cari_value: this.cari_value
            })
        })
            .then(res => res.json())
            .then(res_data => {
                // this.list_data = res_data.data;
                // this.page_last = res_data.jml_data;
                // console.log(res_data);
                var struktur_organisasi = res_data[0];
                this.uraian = struktur_organisasi.uraian;
            });
        },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},
// ================== PAGINASI ====================

            




        },

        mounted() {
            this.getView();
        }
    }
</script>
 